import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { useGetTaxHistoryQuery } from "@/services/tax-history";
import { useFilterState } from "../ducks/hooks/state";
import { DataTable } from "../component/data-table";
import { Load } from "components/load";
import { columns } from "../component/columns";
import PageError from "components/page-error";
import { TaxTypeEnum, TaxTypeRequestEnum } from "@/enum/tax-history";

export const TaxHistory: React.FC = () => {
  const filterState = useFilterState();

  const baseFilters = {
    meta: {
      page: filterState.filters.meta?.page || 1,
      perPage: filterState.filters.meta?.perPage || 10,
    },
  };

  const dynamicFilters = Object.entries(filterState.filters).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] =
          key === "type"
            ? (value as TaxTypeEnum)
            : key === "tax_type_request"
              ? (value as TaxTypeRequestEnum)
              : value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );

  const filters = { ...baseFilters, ...dynamicFilters };

  const { data: taxHistory, isLoading, isFetching, error } = useGetTaxHistoryQuery(filters);

  const { data, meta } = taxHistory || {
    data: [],
    meta: { page: 1, perPage: 10, total: 0, totalPages: 0 },
  };

  if (isLoading) return <Load />;
  if (error) return <PageError status={500} message="Erro ao buscar dados" />;

  return (
    <PageLayout>
      <PageTitle
        title="Histórico de Solicitações Fiscais"
        description="Gerencie o histórico de solicitações fiscais dos usuários"
      />
      <ContentContainer>
        <DataTable data={data} columns={columns} meta={meta} isLoading={isFetching} />
      </ContentContainer>
    </PageLayout>
  );
};
